<div class="login-page">
  <div class="container d-flex align-items-center">
    <div class="form-holder has-shadow">
      <div class="row">
        <!-- Logo & Information Panel-->
        <div class="col-lg-6">
          <div class="info d-flex align-items-center blue-bg">
            <div class="content">
              <div class="logo">
                <img src="assets/images/logo2.png" width="100%" />
              </div>
            </div>
          </div>
        </div>
        <!-- Form Panel    -->
        <div class="col-lg-6 bg-white">
          <div class="form d-flex align-items-center">
            <div class="content">
              <form
                (ngSubmit)="submit()"
                [formGroup]="forgotForm"
                class="form-validate"
                novalidate
                *ngIf="!resetForm && !forgotLoading"
              >
                <div class="form-group">
                  <p>Please type your email.</p>
                  <input
                    type="text"
                    formControlName="email"
                    autocomplete="off"
                    class="input-material"
                    placeholder="Email"
                    [disableControl]="!(loading$ | async)"
                  />
                  <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)">
                    <div *ngIf="f.email.errors" class="required-text">
                      <div *ngIf="f.email.errors.required">Please enter an email address.</div>
                    </div>
                  </div>
                </div>
                <button
                  class="btn btn-primary"
                  type="submit"
                  [disabled]="forgotForm.invalid || (loading$ | async)"
                  id="login"
                >
                  <ng-container *ngIf="!(loading$ | async)">
                    <span translate>Submit</span>
                  </ng-container>
                  <ng-container *ngIf="loading$ | async">
                    <span translate>Loading..</span>
                  </ng-container>
                </button>
                <!-- This should be submit button but I replaced it with <a> for demo purposes-->
              </form>
              <form
                (ngSubmit)="reset()"
                [formGroup]="forgotForm"
                class="form-validate"
                novalidate
                *ngIf="resetForm && !forgotLoading"
              >
                <div class="form-group">
                  <input
                    type="text"
                    formControlName="email"
                    autocomplete="off"
                    class="input-material"
                    placeholder="Email"
                    readonly
                  />
                  <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)">
                    <div *ngIf="f.email.errors" class="required-text">
                      <div *ngIf="f.email.errors.required">Please enter an email address.</div>
                    </div>
                  </div>
                </div>
                <div class="form-group pos_rlt">
                  <input
                    [type]="hide ? 'password' : 'text'"
                    formControlName="password"
                    autocomplete="off"
                    class="input-material"
                    placeholder="password"
                    [disableControl]="!(loading$ | async)"
                  />
                  <mat-icon matSuffix class="pass-toggle" (click)="hide = !hide">{{
                    hide ? 'visibility_off' : 'visibility'
                  }}</mat-icon>
                </div>
                <button
                  class="btn btn-primary"
                  type="submit"
                  [disabled]="forgotForm.invalid || (loading$ | async)"
                  id="login"
                >
                  <ng-container *ngIf="!(loading$ | async)">
                    <span translate>Submit</span>
                  </ng-container>
                  <ng-container *ngIf="loading$ | async">
                    <span translate>Loading..</span>
                  </ng-container>
                </button>
                <!-- This should be submit button but I replaced it with <a> for demo purposes-->
              </form>
              <a class="signup white" [routerLink]="['/login']">Go back</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
